import { z } from "zod";
import { e164PhoneSchema, isoDateSchema, objectIdSchema } from "./common";
export const networkTypeEnum = z.enum(["WIFI", "MOBILE", "OFFLINE", "UNKNOWN"]);
export const simSlotSchema = z.object({
    slot: z.number().int().min(0).max(1),
    subscriptionId: z.number().int(),
    carrier: z.string().min(1).max(60),
    number: e164PhoneSchema.nullable(),
});
export const deviceSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    name: z.string().min(1).max(80),
    model: z.string().min(1).max(80),
    manufacturer: z.string().min(1).max(80),
    androidVersion: z.string().min(1).max(20),
    appVersion: z.string().min(1).max(20),
    simSlots: z.array(simSlotSchema).max(2).default([]),
    isEnabled: z.boolean(),
    isDefault: z.boolean(),
    lastHeartbeatAt: isoDateSchema.nullable(),
    batteryLevel: z.number().int().min(0).max(100).nullable(),
    isCharging: z.boolean().nullable(),
    networkType: networkTypeEnum,
    fcmToken: z.string().nullable(),
    queueDepth: z.number().int().min(0).default(0),
    pairedAt: isoDateSchema,
    // Server-internal — sha256 of the long-lived token issued at pairing time, used to
    // authenticate /device-api/* requests. Never returned to any client (see devicePublicSchema).
    deviceTokenHash: z.string(),
});
export const devicePublicSchema = deviceSchema.omit({
    fcmToken: true,
    userId: true,
    deviceTokenHash: true,
});
/** Online = enabled and a heartbeat within this window, used by device-resolution logic. */
export const DEVICE_ONLINE_WINDOW_MS = 3 * 60 * 1000;
export const requestPairingTokenSchema = z.object({
    deviceName: z.string().min(1).max(80).optional(),
});
export const pairDeviceSchema = z.object({
    pairingToken: z.string().min(1),
    name: z.string().min(1).max(80),
    model: z.string().min(1).max(80),
    manufacturer: z.string().min(1).max(80),
    androidVersion: z.string().min(1).max(20),
    appVersion: z.string().min(1).max(20),
    simSlots: z.array(simSlotSchema).max(2).default([]),
    fcmToken: z.string().min(1),
});
/** Returned exactly once, at pairing time — the raw device token, never retrievable again. */
export const pairDeviceResponseSchema = z.object({
    device: devicePublicSchema,
    deviceToken: z.string(),
});
export const patchDeviceSchema = z.object({
    name: z.string().min(1).max(80).optional(),
    isEnabled: z.boolean().optional(),
    isDefault: z.boolean().optional(),
});
export const heartbeatSchema = z.object({
    batteryLevel: z.number().int().min(0).max(100),
    isCharging: z.boolean(),
    networkType: networkTypeEnum,
    queueDepth: z.number().int().min(0),
    appVersion: z.string().min(1).max(20).optional(),
    // FCM registration tokens rotate (app reinstall, restored backup, Google's own refresh), and
    // pairing happens exactly once. Without a way to carry the current token the server would
    // keep pushing to a dead token forever, silently degrading every send to poll latency.
    fcmToken: z.string().min(1).max(512).optional(),
});
//# sourceMappingURL=device.js.map